export default __webpack_public_path__ + "static/media/estraG.c69d7c9e.png";